import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-map-silder',
  templateUrl: './map-silder.component.html',
  styleUrls: ['./map-silder.component.scss']
})
export class MapSilderComponent implements OnInit, OnChanges {

  @Input() availableDates: string[];
  @Input() imagePath: string;
  // filteredDates: string[];
  sliderValue: number;
  selectedStart: Date;
  selectedImg: string;
  isRunning = true;
  private intervalSubscription: Subscription;
  mgnButtonLabel = 'Pause';
  mgnButtonIcon = 'fas fa-pause';
  tmp: number;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.triggerInterval(0);
  }

  triggerInterval(initialSlider: number) {
    this.sliderValue = initialSlider;

    if (this.intervalSubscription != null) {
      this.intervalSubscription.unsubscribe();
    }

    this.intervalSubscription = interval(1000).pipe(
      map(() => this.sliderValue++),
    ).subscribe(currentSliderValue => {
      this.selectedImg = `${this.imagePath}${this.availableDates[currentSliderValue]}.jpg`;
      if (currentSliderValue >= this.availableDates.length - 1) {
        this.triggerInterval(0);
      }
      return currentSliderValue;
    });
  }

  pauseSlider() {
    this.isRunning = !this.isRunning;
    if (!this.isRunning) {
      this.mgnButtonLabel = 'Play';
      this.mgnButtonIcon = 'fas fa-play';
      this.intervalSubscription.unsubscribe();
    } else {
      this.mgnButtonLabel = 'Pause';
      this.mgnButtonIcon = 'fas fa-pause';
      this.triggerInterval(this.sliderValue);
    }
  }

  onSlideEnd(event) {
    this.handleChange(event);
  }

  onChange(event) {
    this.handleChange(event);
  }

  handleChange(event) {
    this.sliderValue = event.value;
    this.selectedImg = `${this.imagePath}${this.availableDates[this.sliderValue]}.jpg`;
    if (this.isRunning) {
      this.triggerInterval(this.sliderValue);
    }
  }
}
